const vec3 = (x, y, z) => ({ x, y, z });
const normalize2D = (dx, dy) => {
    const len = Math.sqrt(dx * dx + dy * dy);
    if (len < 1e-9)
        return vec3(1, 0, 0);
    return vec3(dx / len, dy / len, 0);
};
/**
 * Extracts two horizontal room axes from polygon2d (longest edge direction)
 * Falls back to bbox2d, then world XY axes.
 */
export const getRoomAxes = (mcbimSpace) => {
    const polygon = mcbimSpace.geometry?.polygon2d ?? mcbimSpace.geometry?.bbox2d;
    if (polygon && polygon.length >= 2) {
        const axisA = getLongestEdgeDirection(polygon);
        const axisB = vec3(-axisA.y, axisA.x, 0); // 90° CCW perpendicular
        return { axisA, axisB };
    }
    // Ultimate fallback: world axes
    return {
        axisA: vec3(1, 0, 0),
        axisB: vec3(0, 1, 0),
    };
};
const getLongestEdgeDirection = (polygon) => {
    let maxLen = -1;
    let bestAxis = vec3(1, 0, 0);
    for (let i = 0; i < polygon.length - 1; i++) {
        const [x0, y0] = polygon[i];
        const [x1, y1] = polygon[i + 1];
        const dx = x1 - x0;
        const dy = y1 - y0;
        const len = Math.sqrt(dx * dx + dy * dy);
        if (len > maxLen) {
            maxLen = len;
            bestAxis = normalize2D(dx, dy);
        }
    }
    return bestAxis;
};
